import { Component, OnInit } from "@angular/core";
import { Organisation } from "./../../models/organisation";
import { VproService } from "./../../service/vpro/vpro.service";

import Swal from "sweetalert2";
import { Utils } from "src/app/common/utils";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-info-basic",
  templateUrl: "./info-basic.component.html",
  styleUrls: ["./info-basic.component.css"],
})
export class InfoBasicComponent implements OnInit {
  organisation = new Organisation();
  submitted = false;
  zipRegex = Utils.zipRegex;
  emailpat = Utils.emailpat;
  // opurl: String = "";
  // op_content_type: String = "";
  // ppfile: File = null;
  constructor(private organisationService: VproService, private router: Router, private spinner: NgxSpinnerService,) { }

  ngOnInit() {
    this.organisation.usereid = localStorage.getItem("usethis") || localStorage.getItem("LogUsr");
  }

  async addOrg() {
    this.submitted = true;
    this.save();
  }

  private save(): void {
    let data: any;
    this.spinner.show();
    this.organisationService.addOrg(this.organisation).subscribe(res => {
      this.spinner.hide();
      // SweetAlert
      Swal.fire({
        position: "top",
        type: "success",
        title: "Organisation details has been stored",
        showConfirmButton: false,
        timer: 1700,
      });
      this.router.navigate(["/login"]);
    }, error => {
      this.spinner.hide();
      // SweetAlert
      Swal.fire({
        allowOutsideClick: false,
        position: "top",
        type: "error",
        title:
          "Something went wrong. Please try again later.",
        showConfirmButton: false,
        timer: 2100
      });
    });

    //   if (this.opurl && this.op_content_type) {
    //     data.opurl = this.opurl;
    //     data.op_content_type = this.op_content_type;
    //   }
    // }

    // public fileSelected(files) {
    //   if (files && files.length > 0) {
    //     this.ppfile = files[0];

    //     this.opurl = files[0].name;
    //     this.op_content_type = files[0].type;
    //   }
    // }
  }
}